var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookRoundColorIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-round-color-icon 1",
    clipPath: "url(#clip0_1758_8722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12C24 5.37242 18.6276 0 12 0C5.37242 0 0 5.37242 0 12C0 17.628 3.87442 22.3497 9.10114 23.6468V15.667H6.62664V12H9.10114V10.42C9.10114 6.33525 10.9495 4.44212 14.9592 4.44212C15.7198 4.44212 17.0315 4.59159 17.5681 4.74059V8.06475C17.2847 8.03505 16.7929 8.01996 16.1818 8.01996C14.2142 8.01996 13.4537 8.76542 13.4537 10.7033V12H17.3734L16.7 15.667H13.4537V23.9123C19.3957 23.1947 24 18.1353 24 12Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7004 15.6672L17.3737 12.0003H13.454V10.7036C13.454 8.76568 14.2145 8.02022 16.1822 8.02022C16.7932 8.02022 17.285 8.03531 17.5684 8.06502V4.74085C17.0318 4.59185 15.7201 4.44238 14.9595 4.44238C10.9498 4.44238 9.10145 6.33598 9.10145 10.4202V12.0003H6.62695V15.6672H9.10145V23.6471C10.0299 23.8772 11.0007 24.0003 12.0003 24.0003C12.4926 24.0003 12.9773 23.9701 13.454 23.9126V15.6672H16.7004Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1758_8722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookRoundColorIcon1);
export default __webpack_public_path__ + "static/media/facebook-round-color-icon 1.f9754306b94a9660c0a622283a3932e5.svg";
export { ForwardRef as ReactComponent };